import {useEffect} from 'react';
import {useAuthContext} from 'Shared/Security/Domain/Contexts/authContext';

function Logout() {
  const {logout} = useAuthContext();
  useEffect(() => logout());
  return null;
}

export default Logout;
